import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Component } from "react";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Footer from "./Layout/Footer";
import Header from "./Layout/Header";
import Layout from "./Layout/Layout";
import SidebarAdmin from "./Layout/SidebarAdmin";
import Announcement from './components/Announcement';
import Application from "./components/Application";
import ApplicationList from "./components/ApplicationList";
import CommonDetailsForm from "./components/CommonAddressPage/CommonDetailsForm";
import ConsumableItemAdd from "./components/ConsumableItemAdd";
import ConsumableItemList from "./components/ConsumableItemList";
import Dashboard from "./components/Dashboard";
import DeliveryChallanAdd from "./components/DeliveryChallanAdd";
import DeliveryChallanList from "./components/DeliveryChallanList";
import DeliveryChallanView from "./components/DeliveryChallanView";
import DepartmentList from "./components/DepartmentList";
import EmployeeAdd from "./components/EmployeeAdd";
import EmployeeEdit from "./components/EmployeeEdit";
import EmployeeList from "./components/EmployeeList";
import EmployeeView from './components/EmployeeView';
import Expense from './components/Expense';
import ExpenseReport from './components/ExpenseReport';
import ItemAdd from "./components/ItemAdd";
import ItemList from "./components/ItemList";
import JobList from "./components/JobList";
import LabourAdd from "./components/LabourAdd";
import LabourList from "./components/LabourList";
import Login from "./components/Login";
import OTList from "./components/OTList";
import Payment from './components/Payment';
import PurchaseOrderAdd from "./components/PurchaseOrderAdd";
import PurchaseOrderList from "./components/PurchaseOrderList";
import PurchaseOrderView from "./components/PurchaseOrderView";
import Register from "./components/Register";
import SalaryDetails from './components/SalaryDetails';
import SalaryList from './components/SalaryList';
import SalaryView from './components/SalaryView';
import UOMAdd from "./components/UOMAdd";
import UOMList from "./components/UOMList";
import UploadPage from "./components/UploadPage";
import VendorWorkOrderAdd from "./components/VendorWorkOrderAdd";
import VendorWorkOrderListPage from "./components/VendorWorkOrderList";
import VendorWorkOrderView from "./components/VendorWorkOrderView";
import AddAdvancePayment from "./components/advancePayment/AddAdvancePayment";
import AdvancePaymentList from "./components/advancePayment/AdvancePaymentList";
import AddExpense from "./components/allExpenses/AddExpense";
import AddExpenseHeader from "./components/allExpenses/AddExpenseHeader";
import EditExpenseHeader from "./components/allExpenses/EditExpenseHeader";
import ExpenseDetails from "./components/allExpenses/ExpenseDetails";
import ExpenseHeaderList from "./components/allExpenses/ExpenseHeaderList";
import ExpenseList from "./components/allExpenses/ExpenseList";
import AddNewCategory from "./components/allExpenses/categories/AddNewCategory";
import CategoryList from './components/allExpenses/categories/CategoryList';
import AssignProject from './components/assignProjects/AssignProject';
import AddAttendance from "./components/attendanceList/AddAttendance";
import AttendanceList from "./components/attendanceList/AttendanceList";
import AddCustomer from "./components/customers/AddCustomer";
import CustomerList from "./components/customers/CustomersList";
import ExitEmployeeList from "./components/employee/ExitEmployeeList";
import ViewExitEmployee from "./components/employee/ViewExitEmployee";
import AddFine from "./components/fine/AddFine";
import FineList from "./components/fine/FineList";
import MeasurementBillAdd from "./components/measurementBillDetatils/MeasurementBillAdd";
import MeasurementBillList from "./components/measurementBillDetatils/MeasurementBillList";
import MeasurementBillView from "./components/measurementBillDetatils/MeasurementBillView";
import AddPermissionCode from "./components/permissionCodes/AddPermissionCode";
import PermissionCodeList from "./components/permissionCodes/PermissionCodeList";
import AddDaysPage from "./components/projects/AddDaysPage";
import AddProject from "./components/projects/AddProject";
import ProjectList from "./components/projects/ProjectList";
import AddRole from "./components/role/AddRole";
import GiveAuthorization from "./components/role/GiveAuthorization";
import RoleList from "./components/role/RoleList";
import EditSalary from "./components/salaryGeneration/EditSalary";
import MonthlySalary from "./components/salaryGeneration/MonthlySalary";
import AddVendor from "./components/vendors/AddVendor";
import VendorList from "./components/vendors/VendorList";
import WorkOrderAdd from "./components/workOrder/WorkOrderAdd";
import WorkOrderList from "./components/workOrder/WorkOrderList";
import WorkOrderView from "./components/workOrder/WorkOrderView";
import withAuth from "./withAuth";

export default class App extends Component {
  componentDidMount() {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    if (typeof window.$ === "undefined" && typeof window.jQuery !== "undefined") {
      window.$ = window.jQuery;
    }

    // Optionally initialize sidebar
    setTimeout(() => {
      window.$('[data-widget="treeview"]').Treeview?.(); // if you use treeview
    }, 500);

  }
  render() {
    return (
      <>
        <Router>
          <Switch>
            <Route exact path="/login" component={LoginContainer} />
            <Route path="/" component={withAuth(DefaultContainer)} />
          </Switch>
        </Router>
      </>
    )
  }
}

const LoginContainer = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative", height: "600px" }}>
    <Route exact path="/" render={() => <Redirect to="/login" />} />
    <Route path="/login" component={Login} />
  </div>
)

const DefaultContainer = () => (
  <div>
    {JSON.parse(localStorage.getItem('user')).role === "ROLE_ADMIN" ? (
      AdminContainer()
    ) : null}
  </div>
)


const AdminContainer = () => (
  <div className="wrapper">
    <Header />
    <SidebarAdmin />
    <Layout>
      <Switch>
        <Route exact path="/" component={withAuth(Dashboard)} />
        <Route exact path="/login" component={Login} />
        <Route exact path='/customer-add' component={AddCustomer} />
        <Route exact path='/customer-edit/:id' component={AddCustomer} />
        <Route exact path='/role-list' component={RoleList} />
        <Route exact path='/authorization/:id' component={GiveAuthorization} />
        <Route exact path='/permission-code-add' component={AddPermissionCode} />
        <Route exact path='/permission-code-edit/:id' component={AddPermissionCode} />
        <Route exact path='/permission-code-list' component={PermissionCodeList} />
        <Route exact path='/role-add' component={AddRole} />
        <Route exact path='/customer-list' component={CustomerList} />
        <Route exact path="/employee-list" component={withAuth(EmployeeList)} />
        <Route exact path="/exit-employee-list" component={withAuth(ExitEmployeeList)} />
        <Route exact path="/employee-add" component={withAuth(EmployeeAdd)} />
        <Route exact path="/employee-view" component={withAuth(EmployeeView)} />
        <Route exact path="/exit-employee-view" component={withAuth(ViewExitEmployee)} />
        <Route exact path="/employee-edit" component={withAuth(EmployeeEdit)} />
        <Route exact path="/departments" component={withAuth(DepartmentList)} />
        <Route exact path="/job-list" component={withAuth(JobList)} />
        <Route exact path="/application-list" component={withAuth(ApplicationList)} />
        <Route exact path="/application" component={withAuth(Application)} />
        <Route exact path="/application/:id" component={withAuth(Application)} />
        <Route exact path="/salary-details" component={withAuth(SalaryDetails)} />
        <Route exact path="/salary-list" component={withAuth(SalaryList)} />
        <Route exact path="/salary-view" component={withAuth(SalaryView)} />
        <Route exact path="/payment" component={withAuth(Payment)} />
        <Route exact path="/expense" component={withAuth(Expense)} />
        <Route exact path="/expense-report" component={withAuth(ExpenseReport)} />
        <Route exact path="/announcement" component={withAuth(Announcement)} />
        <Route exact path="/register" component={Register} />
        <Route exact path='/vendor-add' component={AddVendor} />
        <Route exact path='/vendor-list' component={VendorList} />
        <Route exact path='/project-add' component={AddProject} />
        <Route exact path='/project-edit/:id' component={AddProject} />
        <Route exact path='/project-list' component={ProjectList} />
        <Route exact path='/advance-pay-add' component={AddAdvancePayment} />
        <Route exact path='/advance-pay-list' component={AdvancePaymentList} />
        <Route exact path='/fine-add' component={AddFine} />
        <Route exact path='/fine-list' component={FineList} />
        <Route exact path='/upload' component={UploadPage} />
        <Route exact path='/assign-project' component={AssignProject} />
        <Route exact path='/monthly-salary' component={MonthlySalary} />
        <Route exact path='/add-expense' component={AddExpense} />
        <Route exact path='/expense-details-list/:id' component={ExpenseDetails} />
        <Route exact path='/expense-header-details/:id' component={EditExpenseHeader} />
        <Route exact path='/expense-list' component={ExpenseList} />
        <Route exact path='/add-expense-category' component={AddNewCategory} />
        <Route exact path='/expense-category-list' component={CategoryList} />
        <Route exact path='/add-expense-header' component={AddExpenseHeader} />
        <Route exact path='/add-days/:id' component={AddDaysPage} />
        <Route exact path='/edit-salary/:id' component={EditSalary} />
        <Route exact path='/expense-header-list' component={ExpenseHeaderList} />
        <Route exact path='/attendance-list' component={AttendanceList} />
        <Route exact path='/ot-list' component={OTList} />
        <Route exact path={`/customer-address/:type/:id`} component={CommonDetailsForm} />
        <Route exact path={`/vendor-address/:type/:id`} component={CommonDetailsForm} />
        <Route exact path='/UOMList' component={UOMList} />
        <Route exact path="/UOM-add" component={withAuth(UOMAdd)} />
        <Route exact path="/UOM-add/:id" component={withAuth(UOMAdd)} />
        <Route exact path='/ItemList' component={ItemList} />
        <Route exact path="/Item-add" component={withAuth(ItemAdd)} />
        <Route exact path="/Item-add/:id" component={withAuth(ItemAdd)} />
        <Route exact path='/LabourList' component={LabourList} />
        <Route exact path="/Labour-add" component={withAuth(LabourAdd)} />
        <Route exact path="/Labour-add/:id" component={withAuth(LabourAdd)} />
        <Route exact path='/ConsumableItemList' component={ConsumableItemList} />
        <Route exact path="/ConsumableItem-add" component={withAuth(ConsumableItemAdd)} />
        <Route exact path="/ConsumableItem-add/:id" component={withAuth(ConsumableItemAdd)} />
        <Route exact path='/PurchaseOrderList' component={PurchaseOrderList} />
        <Route exact path="/PurchaseOrder-add" component={withAuth(PurchaseOrderAdd)} />
        <Route exact path="/PurchaseOrder-edit/:id" component={withAuth(PurchaseOrderAdd)} />
        <Route exact path="/PurchaseOrder-view/:id" component={withAuth(PurchaseOrderView)} />
        <Route exact path='/DeliveryChallanList' component={DeliveryChallanList} />
        <Route exact path='/DeliveryChallan-add' component={DeliveryChallanAdd} />
        <Route exact path='/DeliveryChallan-edit/:id' component={DeliveryChallanAdd} />
        <Route exact path='/deliveryChallan-view/:id' component={DeliveryChallanView} />
        <Route exact path='/add-attendance' component={AddAttendance} />
        <Route exact path='/add-vendor-work-order' component={VendorWorkOrderAdd} />
        <Route exact path="/vendorWorkOrder-edit/:id" component={withAuth(VendorWorkOrderAdd)} />
        <Route exact path="/vendor-work-order-view/:id" component={withAuth(VendorWorkOrderView)} />
        <Route exact path='/vendor-work-order-list' component={VendorWorkOrderListPage} />
        <Route exact path='/work-order' component={WorkOrderList} />
        <Route exact path="/work-order-add" component={withAuth(WorkOrderAdd)} />
        <Route exact path="/work-order-edit/:id" component={withAuth(WorkOrderAdd)} />
        <Route exact path="/work-order-view/:id" component={withAuth(WorkOrderView)} />

        <Route exact path='/measurement-bill' component={MeasurementBillList} />
        <Route exact path="/measurement-bill-add" component={withAuth(MeasurementBillAdd)} />
        <Route exact path="/measurement-bill-edit/:id" component={withAuth(MeasurementBillAdd)} />
        <Route exact path="/measurement-bill-view/:id" component={withAuth(MeasurementBillView)} />

      </Switch>
    </Layout>
    <Footer />
  </div>
)


